import { TweenMax } from 'gsap';

export default function ui(el) {
  TweenMax.set(el, {
    y: 30,
    autoAlpha: 0,
  });

  return el;
}
